"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfOrderIsSuitableForJunior = checkIfOrderIsSuitableForJunior;
exports.getAddress = getAddress;
exports.getBeginWorkDate = getBeginWorkDate;
exports.getBrandPaymentMethod = getBrandPaymentMethod;
exports.getDoneDate = getDoneDate;
exports.getIsClothesWithOnlyRemaillage = void 0;
exports.getNextRdv = getNextRdv;
exports.getReferrer = getReferrer;
exports.getReturnReadyDate = getReturnReadyDate;
exports.getWaitingPaymentCouturierDate = getWaitingPaymentCouturierDate;
exports.hasBrandPayingPromoCode = hasBrandPayingPromoCode;
exports.hasBrandPromoCode = hasBrandPromoCode;
exports.hasClothes = hasClothes;
exports.hasCurtains = hasCurtains;
exports.hasLeatherGoods = hasLeatherGoods;
exports.hasShoes = hasShoes;
exports.hasTextile = hasTextile;
exports.reindexClothesName = void 0;
var _index = require("../pricings/index");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getBrandPromoCode(order) {
  var _order$discounts;
  return (_order$discounts = order.discounts) === null || _order$discounts === void 0 ? void 0 : _order$discounts.find(function (discount) {
    return !!discount.brand;
  });
}
function hasBrandPromoCode(order) {
  return Boolean(getBrandPromoCode(order));
}
function hasBrandPayingPromoCode(order) {
  return Boolean(getBrandPromoCode(order) && !getBrandPromoCode(order).doesBrandNotPay);
}

// precondition: order hydrated with popup store and brandPromoCode.brand (if applicable to this order)
function getBrandPaymentMethod(order) {
  var _order$popupStore, _order$brandPromoCode, _order$brandPromoCode2;
  return ((_order$popupStore = order.popupStore) === null || _order$popupStore === void 0 ? void 0 : _order$popupStore.paymentMethod) || ((_order$brandPromoCode = order.brandPromoCode) === null || _order$brandPromoCode === void 0 ? void 0 : (_order$brandPromoCode2 = _order$brandPromoCode.brand) === null || _order$brandPromoCode2 === void 0 ? void 0 : _order$brandPromoCode2.paymentMethod);
}
function getReferrer(order) {
  var discountReferrer = order.discounts && order.discounts.find(function (discount) {
    return discount.referrer;
  });
  return discountReferrer ? discountReferrer.referrer : null;
}
var sanitizeAddress = function sanitizeAddress(address) {
  var _address$zipcode, _address$zipcode$trim, _address$locality, _address$locality$tri, _address$street, _address$street$trim;
  if (!address) return null;
  return _objectSpread(_objectSpread({}, address), {}, {
    zipcode: (_address$zipcode = address.zipcode) === null || _address$zipcode === void 0 ? void 0 : (_address$zipcode$trim = _address$zipcode.trim) === null || _address$zipcode$trim === void 0 ? void 0 : _address$zipcode$trim.call(_address$zipcode),
    locality: (_address$locality = address.locality) === null || _address$locality === void 0 ? void 0 : (_address$locality$tri = _address$locality.trim) === null || _address$locality$tri === void 0 ? void 0 : _address$locality$tri.call(_address$locality),
    street: (_address$street = address.street) === null || _address$street === void 0 ? void 0 : (_address$street$trim = _address$street.trim) === null || _address$street$trim === void 0 ? void 0 : _address$street$trim.call(_address$street)
  });
};

// Precondition need to be hydrated with customer
function getAddress(order) {
  if (!order) return null;
  if (order.addressSaved) return sanitizeAddress(order.addressSaved);
  if (!order.customer || _typeof(order.customer) !== 'object') {
    return null;
  }
  if (_typeof(order.address) !== 'object') {
    return sanitizeAddress(order.customer.address);
  }
  if (_typeof(order.customer.addresses) !== 'object') {
    return null;
  }
  if (!order.address) {
    return null;
  }
  return sanitizeAddress(order.customer.addresses.find(function (address) {
    return order.address.equals(address._id);
  }));
}
var reindexClothesName = exports.reindexClothesName = function reindexClothesName(clothes) {
  return clothes.map(function (cloth, index) {
    var clothNumber = clothes.filter(function (clothIt, indexIt) {
      return clothIt.slug === cloth.slug && index >= indexIt;
    }).length;
    var clothName = (cloth.name || cloth.slug).replace(/\d/, '').replace('n°', '').trim();
    return _objectSpread(_objectSpread({}, cloth), {}, {
      clothNumber: clothNumber,
      clothName: clothName,
      name: "".concat(clothName, " n\xB0").concat(clothNumber)
    });
  });
};
function getNextRdv(order) {
  var _order$rdv, _order$rdv2, _order$rdv3, _order$rdv4;
  if (!(order !== null && order !== void 0 && order.state)) return undefined;
  switch (order.state) {
    case 'ACTIVATION':
    case 'WAITING_COUTURIER_ANSWER':
    case 'WAITING_COUTURIER_ANSWER_CHANGE_RDV1':
    case 'COUTURIER_REFUSAL':
    case 'ORDER_CONFIRMATION':
    case 'RDV_1':
      return (_order$rdv = order.rdv1) !== null && _order$rdv !== void 0 && _order$rdv.begin ? {
        type: 'RDV_1',
        date: order.rdv1.begin
      } : undefined;
    case 'WAITING_PAYMENT_CUSTOMER':
    case 'WAITING_PAYMENT_BRAND':
    case 'ONGOING_MISSION':
    case 'DELIVERY_PREPARATION':
    case 'RDV_2':
    case 'RETAIL_ACTIVATION':
    case 'RETAIL_ONGOING':
    case 'RETAIL_RETURN_READY':
      return (_order$rdv2 = order.rdv2) !== null && _order$rdv2 !== void 0 && _order$rdv2.begin ? {
        type: 'RDV_2',
        date: order.rdv2.begin
      } : undefined;
    case 'ADJUSTMENT':
    case 'RDV_3':
      return (_order$rdv3 = order.rdv3) !== null && _order$rdv3 !== void 0 && _order$rdv3.begin ? {
        type: 'RDV_3',
        date: (_order$rdv4 = order.rdv3) === null || _order$rdv4 === void 0 ? void 0 : _order$rdv4.begin
      } : undefined;
    case 'WAITING_PAYMENT_COUTURIER':
    case 'DONE':
    case 'CANCELED':
    case 'RETAIL_WAITING_PAYMENT_COUTURIER':
    case 'RETAIL_DONE':
    case 'RETAIL_CANCELED':
    default:
      return undefined;
  }
}
function hasCurtains(order) {
  var curtainsInClothes = order.clothes && order.clothes.reduce(function (hasCurtainsIt, cloth) {
    return hasCurtainsIt || cloth.slug === 'deco';
  }, false);
  var curtainsFabrics = ['curtain', 'netCurtain', 'heavyCurtain'];
  var curtainsInFabrics = order.fabrics && order.fabrics.reduce(function (hasCurtainsIt, fabric) {
    return hasCurtainsIt || curtainsFabrics.includes(fabric);
  }, false);
  return curtainsInClothes || curtainsInFabrics;
}

// clothes, by opposition to curtains
// TODO: find better wording to distinguish orders.clothes = clothes + curtains
function hasClothes(order) {
  return order.clothes && order.clothes.reduce(function (hasClothesIt, cloth) {
    return hasClothesIt || cloth.slug !== 'deco';
  }, false);
}
var doneStates = ['DONE', 'RETAIL_DONE', 'PACKAGE_DONE'];
function getDoneDate(order) {
  if (!order || !order.logs) {
    return null;
  }
  var doneLog = order.logs.filter(function (log) {
    return log.type === 'CHANGE_STATE';
  }).find(function (log) {
    return doneStates.includes(log.newValue);
  });
  return doneLog && doneLog.date;
}
var returnReadyStates = ['PACKAGE_RETURN_READY', 'RETAIL_RETURN_READY', 'RETAIL_WAITING_PAYMENT_COUTURIER'];
function getReturnReadyDate(order) {
  if (!order || !order.logs) {
    return null;
  }
  var returnReadyLog = order.logs.filter(function (log) {
    return log.type === 'CHANGE_STATE';
  }).find(function (log) {
    return returnReadyStates.includes(log.newValue);
  });
  return returnReadyLog && returnReadyLog.date;
}
function getBeginWorkDate(order) {
  var _order$rdv5, _order$rdv6, _order$process;
  if (order !== null && order !== void 0 && (_order$rdv5 = order.rdv1) !== null && _order$rdv5 !== void 0 && _order$rdv5.begin) return order === null || order === void 0 ? void 0 : (_order$rdv6 = order.rdv1) === null || _order$rdv6 === void 0 ? void 0 : _order$rdv6.begin;
  if ((_order$process = order.process) !== null && _order$process !== void 0 && _order$process.includes('PACKAGE')) {
    var _order$logs, _order$logs$find;
    var waitingWorkLog = (_order$logs = order.logs) === null || _order$logs === void 0 ? void 0 : (_order$logs$find = _order$logs.find) === null || _order$logs$find === void 0 ? void 0 : _order$logs$find.call(_order$logs, function (log) {
      return ['PACKAGE_WAITING_WORK'].includes(log.newValue);
    });
    return waitingWorkLog === null || waitingWorkLog === void 0 ? void 0 : waitingWorkLog.date;
  }
  return order.createdAt;
}
function getWaitingPaymentCouturierDate(order) {
  if (!order || !order.logs) {
    return null;
  }
  var states = ['WAITING_PAYMENT_COUTURIER', 'RETAIL_WAITING_PAYMENT_COUTURIER', 'WAITING_PICKUP_CUSTOMER_RETURN', 'PACKAGE_WAITING_PAYOUT_COUTURIER'];
  var waitingPaymentCouturierLog = order.logs.find(function (log) {
    return states.includes(log.newValue);
  });
  return waitingPaymentCouturierLog && waitingPaymentCouturierLog.date;
}
function checkIfOrderIsSuitableForJunior(order) {
  var _order$clothes;
  if (JSON.stringify(order.funnelInfo || {}).includes('talkRDV')) return false;
  if ((order.fabrics || []).includes('upcycling')) return false;
  var pricingInverse = (0, _index.getPricingInverse)(order.pricingVersion);
  var isNotSuitableForJunior = !!((_order$clothes = order.clothes) !== null && _order$clothes !== void 0 && _order$clothes.find(function (cloth) {
    if ((cloth.upcyclingItems || []).length !== 0) return true;
    if ((cloth.items || []).length === 0) return true;
    return !!cloth.items.find(function (item) {
      var _pricingInverse$item$;
      return !((_pricingInverse$item$ = pricingInverse[item.id]) !== null && _pricingInverse$item$ !== void 0 && _pricingInverse$item$.isSuitableForJunior);
    });
  }));
  return !isNotSuitableForJunior;
}
var textileSlugs = ['pant', 'haut', 'robe', 'mari', 'mant', 'jupe', 'pull', 'deco', 'ling', 'comb', 'acce', 'little_acce', 'autr', 'crea_tote', 'crea_sac', 'crea_poch', 'crea_hous', 'crea_cana', 'crea_assi', 'crea_doss', 'crea_plai', 'crea_chai', 'crea_stoo', 'crea_ride'];
/** @param { import("../entities/types").Order } order */
function hasTextile(order) {
  var _order$clothes2;
  return Boolean(order === null || order === void 0 ? void 0 : (_order$clothes2 = order.clothes) === null || _order$clothes2 === void 0 ? void 0 : _order$clothes2.find(function (cloth) {
    return textileSlugs.includes(cloth.slug);
  }));
}
var leatherGoodsSlugs = ['bag', 'belt', 'wallet'];

/** @param { import("../entities/types").Order } order */
function hasLeatherGoods(order) {
  var _order$clothes3;
  return Boolean(order === null || order === void 0 ? void 0 : (_order$clothes3 = order.clothes) === null || _order$clothes3 === void 0 ? void 0 : _order$clothes3.find(function (cloth) {
    return leatherGoodsSlugs.includes(cloth.slug);
  }));
}

/** @param { import("../entities/types").Order } order */
function hasShoes(order) {
  var _order$clothes4;
  return Boolean(order === null || order === void 0 ? void 0 : (_order$clothes4 = order.clothes) === null || _order$clothes4 === void 0 ? void 0 : _order$clothes4.find(function (cloth) {
    return cloth.slug.includes('shoes');
  }));
}
var getIsClothesWithOnlyRemaillage = exports.getIsClothesWithOnlyRemaillage = function getIsClothesWithOnlyRemaillage(clothes) {
  return (clothes || []).length > 0 ? clothes.every(function (cloth) {
    return Array.isArray(cloth === null || cloth === void 0 ? void 0 : cloth.items) && cloth.items.length > 0 && cloth.items.every(function (item) {
      return item.id === "13.".concat(cloth.slug, "-rep-tear-7");
    });
  }) : false;
};